module.exports = __webpack_public_path__ + "static/media/coach-icon.b7cf8066.svg";